import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'

import { brand } from '../../../settings/custom/build'

export class LogoSpine extends Spine {
  constructor(data) {
    super(data)
    this._data = data
    const resizeLogo = () => {
      const { stage } = game.models.SizeModel.size
      this.x =   stage.width / 2
      this.y =   stage.height / 2 + 20
      this.scale.x = 0.7
      this.scale.y = 0.7
      if(window.innerHeight > window.innerWidth && brand === 'chill'){
        this.y =   stage.height / 2 - 20
        this.scale.x = 0.2
        this.scale.y = 0.2
      }
    }

    signal.on('LOGO-ANIM:START', () => {
      resizeLogo()
    })

    signal.on('RESIZE', () => {
      resizeLogo()
    })

    this.regular.call(this)
  }

  regular(){
    signal.dispatch('LOGO-ANIM:START')
    this.play('animation', false)
  }
}
